module.exports = __webpack_public_path__ + "static/media/item-2.e87f396e.png";